import { Button } from "@/components/ui/button";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { useTranslation } from "react-i18next";

interface BlogCategoryFilterProps {
  categories: string[];
  selectedCategory: string;
  onSelectCategory: (category: string) => void;
}

export function BlogCategoryFilter({ 
  categories, 
  selectedCategory, 
  onSelectCategory 
}: BlogCategoryFilterProps) {
  const { t } = useTranslation();
  
  const getCategoryTranslation = (category: string): string => {
    // For Japanese categories, return as is
    if (/[\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF]/.test(category)) {
      return category;
    }
    
    // Otherwise translate based on category name
    switch(category.toLowerCase()) {
      case "all":
      case "すべて":
        return t('blog.categories.all');
      case "technology":
      case "技術":
        return t('blog.categories.technology');
      case "travel":
      case "旅行":
        return t('blog.categories.travel');
      case "advice":
      case "アドバイス":
        return t('blog.categories.advice');
      case "lifestyle":
      case "生活":
        return t('blog.categories.lifestyle');
      case "guide":
      case "ガイド":
        return t('blog.categories.guide');
      default:
        return category;
    }
  };

  return (
    <ScrollArea className="w-full whitespace-nowrap">
      <div className="flex space-x-2 p-1">
        {categories.map(category => (
          <Button
            key={category}
            variant={selectedCategory === category ? "default" : "outline"}
            size="sm"
            onClick={() => onSelectCategory(category)}
            className={selectedCategory === category ? "" : "bg-transparent hover:bg-primary/5"}
          >
            {getCategoryTranslation(category)}
          </Button>
        ))}
      </div>
      <ScrollBar orientation="horizontal" />
    </ScrollArea>
  );
}
